import * as C from '@/consts'

/**
 * attrs と追加諸元を統合したものを取得する
 *
 * @param {Object} attrs
 * @param {Array} specs
 * @returns {Array} 統合された主要諸元データを返す
 */
export function getSpecs (attrs, specs) {
  // 並び順を示す連想配列を作成する
  const orders = C.SPECS_ORDER.reduce((orders, name, index) => {
    orders[name] = index
    return orders
  }, {})

  // specs のデータに単位を追加する
  const data = specs.map(item => {
    let value
    switch (item.name) {
      case '車高':
      case '車幅':
      case '全長':
        value = `${item.value} mm`
        break
      case '車重':
        value = `${item.value} kg`
        break
      default:
        value = item.value
    }
    return {
      name: item.name,
      value: value
    }
  })

  // attrs のデータを追加する
  data.push({
    name: '駆動',
    value: attrs.drive ? '4WD' : '2WD'
  })
  data.push({
    name: 'ギア',
    value: attrs.mission ? 'MT' : 'AT'
  })
  data.push({
    name: '排気量',
    value: (attrs.cc > 0) ? `${attrs.cc} cc` : '-'
  })
  data.push({
    name: '燃料',
    value: attrs.fuel ? attrs.fuel : '-'
  })
  data.push({
    name: '乗車',
    value: (attrs.seats > 0) ? `${attrs.seats} 名` : '-'
  })
  if (attrs.bed > 0) {
    data.push({
      name: '就寝',
      value: `${attrs.bed} 名`
    })
  }

  // 並び順を整える
  data.sort((x, y) => {
    return (orders[x.name] | 0) - (orders[y.name] | 0)
  })

  return data
}

/**
 * attrs と追加装備品を統合したものを取得する
 *
 * @param {Object} attrs
 * @param {Array} equipments
 * @returns {Array} 統合された装備品データを返す
 */
export function getEquipments (attrs, equipments) {
  // 並び順を示す連想配列を作成する
  const orders = C.EQUIPMENTS_ORDER.reduce((orders, name, index) => {
    orders[name] = index
    return orders
  }, {})

  const data = [...equipments]
  data.push({
    name: 'ナビ',
    value: attrs.navi ? '○' : '-'
  })
  data.push({
    name: 'ETC',
    value: attrs.etc ? '○' : '-'
  })
  data.push({
    name: 'スタッドレス',
    value: attrs.studless ? '○' : '-'
  })

  // 並び順を整える
  data.sort((x, y) => {
    return (orders[x.name] | 0) - (orders[y.name] | 0)
  })

  return data
}
